module.exports = __webpack_public_path__ + "static/media/PO.8426500d.svg";